import { render } from "./YellowCat.svg?vue&type=template&id=2c31c03a"
const script = {}
script.render = render

export default script